/* Reveal on scroll, mobile nav, and the hover strobe.
   The hidden reveal state is added by script, so no-JS renders a full page. */
(function () {
  "use strict";

  var reduce = false;
  try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}

  /* ---- reveal ---- */
  var els = [].slice.call(document.querySelectorAll(".rev"));
  if (els.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (e) { io.observe(e); });
  } else {
    els.forEach(function (e) { e.classList.add("in"); });
  }

  /* ---- mobile nav ---- */
  var toggle = document.querySelector(".nav-toggle");
  var nav = document.querySelector(".nav");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", String(open));
      // the visible label is swapped by CSS off aria-expanded; only the
      // accessible name is set here, so the button never changes width
      toggle.setAttribute("aria-label", open ? "Close" : "Menu");
    });
  }

  /* ---- menu ------------------------------------------------------------
     CSS :hover alone drops the moment the cursor crosses the gap between the
     menu item and the panel below the header. This holds it open for a beat
     so the pointer can get there, and gives keyboard and touch a real path. */
  var GRACE = 220;
  [].slice.call(document.querySelectorAll(".nav .has-sub")).forEach(function (item) {
    var panel = item.querySelector(".sub");
    var parent = item.querySelector(".sub-parent");
    if (!panel) { return; }
    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      [].slice.call(document.querySelectorAll(".nav .has-sub.open")).forEach(function (o) {
        if (o !== item) { o.classList.remove("open"); setExpanded(o, false); }
      });
      item.classList.add("open");
      setExpanded(item, true);
    }
    function close(now) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove("open");
        setExpanded(item, false);
      }, now ? 0 : GRACE);
    }
    function setExpanded(el, v) {
      var b = el.querySelector(".sub-parent");
      if (b && b.tagName === "BUTTON") { b.setAttribute("aria-expanded", String(v)); }
    }

    // Escape returns focus to the trigger, which fires focusin. Without this
    // flag that reopens the menu Escape just closed.
    var returning = false;

    item.addEventListener("mouseenter", open);
    item.addEventListener("mouseleave", function () { close(false); });
    item.addEventListener("focusin", function () { if (!returning) { open(); } });
    item.addEventListener("focusout", function (e) {
      if (!item.contains(e.relatedTarget)) { close(false); }
    });
    item.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") { return; }
      clearTimeout(closeTimer);
      item.classList.remove("open");
      setExpanded(item, false);
      if (parent) { returning = true; parent.focus(); returning = false; }
    });
    if (parent && parent.tagName === "BUTTON") {
      parent.addEventListener("click", function () {
        if (item.classList.contains("open")) { close(true); } else { open(); }
      });
    }
  });

  document.addEventListener("click", function (e) {
    if (!e.target.closest(".nav .has-sub")) {
      [].slice.call(document.querySelectorAll(".nav .has-sub.open")).forEach(function (o) {
        o.classList.remove("open");
        var b = o.querySelector(".sub-parent");
        if (b && b.tagName === "BUTTON") { b.setAttribute("aria-expanded", "false"); }
      });
    }
  });

  /* ---- hover strobe -------------------------------------------------------
     Advance through a product's shots while the cursor is on the card, firing
     a hard white pop between each one. Reads its timing from theme settings.
     On touch there is no hover, so the first tap advances and the second
     follows the link. */
  var ROOT = getComputedStyle(document.documentElement);
  var INTERVAL = parseInt(ROOT.getPropertyValue("--hover-ms"), 10) || 2200;
  var canHover = true;
  try { canHover = window.matchMedia("(hover: hover)").matches; } catch (e) {}

  [].slice.call(document.querySelectorAll(".card-media[data-shots]")).forEach(function (media) {
    var shots = [].slice.call(media.querySelectorAll(".shot"));
    if (shots.length < 2) { return; }
    var flash = media.querySelector(".card-flash");
    var i = 0, timer = null, advanced = false;

    shots[0].classList.add("on");

    function show(n) {
      shots[i].classList.remove("on");
      i = (n + shots.length) % shots.length;
      shots[i].classList.add("on");
      if (flash && !reduce) {
        flash.classList.remove("pop");
        void flash.offsetWidth;          // restart the animation
        flash.classList.add("pop");
      }
    }

    function start() {
      if (timer || reduce) { return; }
      timer = setInterval(function () { show(i + 1); }, INTERVAL);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
      if (i !== 0) { shots[i].classList.remove("on"); i = 0; shots[0].classList.add("on"); }
      advanced = false;
    }

    if (canHover) {
      media.addEventListener("mouseenter", start);
      media.addEventListener("mouseleave", stop);
      var card = media.closest(".card");
      if (card) {
        card.addEventListener("focusin", start);
        card.addEventListener("focusout", stop);
      }
    } else {
      // touch: first tap advances, second follows the link
      var link = media.closest("a");
      if (link) {
        link.addEventListener("click", function (e) {
          if (!advanced) { e.preventDefault(); show(i + 1); advanced = true; }
        });
      }
    }
  });

  /* ---- cart drawer -------------------------------------------------------
     Re-renders itself through the Section Rendering API after every change, so
     quantities and totals always come from Liquid rather than being patched by
     hand in the browser. */
  var drawer = document.getElementById("cartDrawer");
  if (drawer) {
    var panel = drawer.querySelector(".drawer-panel");
    var lastFocus = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (panel) { panel.focus(); }
    }
    function closeDrawer() {
      drawer.classList.remove("open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    }

    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-close]")) { e.preventDefault(); closeDrawer(); }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("open")) { closeDrawer(); }
    });

    // the header cart link opens the drawer instead of navigating
    [].slice.call(document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]')).forEach(function (a) {
      if (a.closest(".drawer")) { return; }
      a.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
    });

    function refresh(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.getElementById("cartDrawer");
      if (!fresh) { return; }
      var body = drawer.querySelector(".drawer-body");
      var foot = drawer.querySelector(".drawer-foot");
      var head = drawer.querySelector(".drawer-head");
      var nb = fresh.querySelector(".drawer-body");
      var nf = fresh.querySelector(".drawer-foot");
      var nh = fresh.querySelector(".drawer-head");
      if (nb && body) { body.innerHTML = nb.innerHTML; }
      if (nh && head) { head.innerHTML = nh.innerHTML; }
      if (foot) { foot.remove(); }
      if (nf && panel) { panel.appendChild(nf); }
      var count = fresh.querySelector(".drawer-count");
      [].slice.call(document.querySelectorAll("[data-cart-count]")).forEach(function (el) {
        el.textContent = count ? count.textContent.trim() : "";
      });
      /* the drawer just replaced its own buttons, so anything that decorates
         them has to be told to run again */
      document.dispatchEvent(new CustomEvent("cart:refreshed"));
    }

    function notice(msg) {
      var box = drawer.querySelector(".drawer-note");
      if (!box) {
        box = document.createElement("p");
        box.className = "drawer-note";
        box.setAttribute("role", "status");
        var body = drawer.querySelector(".drawer-body") || drawer.querySelector(".drawer-panel") || drawer;
        body.insertBefore(box, body.firstChild);
      }
      box.textContent = msg || "";
      box.hidden = !msg;
    }

    function change(key, qty) {
      drawer.classList.add("busy");
      fetch(drawer.dataset.changeUrl + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty, sections: "cart-drawer" })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          /* A refused change is a normal outcome, not a failure: stock runs out,
             a piece is one of one. Reloading threw the customer out of the drawer
             with no explanation. Say what Shopify said, leave everything open. */
          if (!res.ok) {
            notice(res.data.description || res.data.message || "That quantity is not available.");
            return;
          }
          notice("");
          if (res.data.sections && res.data.sections["cart-drawer"]) {
            refresh(res.data.sections["cart-drawer"]);
          } else {
            window.location.reload();
          }
        })
        .catch(function () { window.location.reload(); })
        .then(function () { drawer.classList.remove("busy"); });
    }

    drawer.addEventListener("click", function (e) {
      var line = e.target.closest(".drawer-line");
      if (!line) { return; }
      var key = line.dataset.key;
      if (e.target.closest("[data-remove]")) { e.preventDefault(); change(key, 0); return; }
      var step = e.target.closest("[data-step]");
      if (step) {
        e.preventDefault();
        var n = parseInt(line.querySelector(".qty-n").textContent, 10) || 1;
        change(key, Math.max(0, n + parseInt(step.dataset.step, 10)));
      }
    });

    // adding from a product form opens the drawer rather than leaving the page
    [].slice.call(document.querySelectorAll('form[action$="/cart/add"]')).forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        drawer.classList.add("busy");
        var fd = new FormData(form);
        fd.append("sections", "cart-drawer");
        fetch(form.action + ".js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.sections && data.sections["cart-drawer"]) { refresh(data.sections["cart-drawer"]); }
            openDrawer();
          })
          .catch(function () { form.submit(); })
          .then(function () { drawer.classList.remove("busy"); });
      });
    });
  }
})();
/* ---- collection rail ------------------------------------------------------
   Scrolls by exactly one tile, and disables an arrow when there is nothing
   further that way, so the control never lies about what it will do. */
(function () {
  function setup(sec) {
    var rail = sec.querySelector("[data-rail]");
    if (!rail) return;
    var prev = sec.querySelector("[data-rail-prev]");
    var next = sec.querySelector("[data-rail-next]");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap || "0") || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    function go(dir) {
      rail.scrollBy({ left: dir * step(), behavior: reduce ? "auto" : "smooth" });
    }
    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }
  [].slice.call(document.querySelectorAll(".rail-head")).forEach(function (h) {
    setup(h.closest("section") || document);
  });
  document.addEventListener("shopify:section:load", function (e) { setup(e.target); });
})();

/* A wide size chart should scroll inside itself rather than pushing the page
   sideways, so any table in long-form content gets its own scroll container. */
(function () {
  [].slice.call(document.querySelectorAll(".doc table")).forEach(function (t) {
    if (t.parentElement && t.parentElement.classList.contains("table-scroll")) return;
    var box = document.createElement("div");
    box.className = "table-scroll";
    box.setAttribute("tabindex", "0");
    box.setAttribute("role", "region");
    t.parentNode.insertBefore(box, t);
    box.appendChild(t);
  });
})();

/* The header wordmark waits until the hero wordmark has scrolled away, so the
   two are never on screen at once. Any page without a hero shows it at once. */
(function () {
  var hdr = document.querySelector(".hdr[data-mark-reveal]");
  if (!hdr) return;
  var hero = document.querySelector(".hero-mark");
  if (!hero) { hdr.classList.add("mark-in"); return; }
  if (!("IntersectionObserver" in window)) { hdr.classList.add("mark-in"); return; }
  new IntersectionObserver(function (entries) {
    hdr.classList.toggle("mark-in", !entries[0].isIntersecting);
  }, { rootMargin: "-40px 0px 0px 0px", threshold: 0 }).observe(hero);
})();

/* Filters apply on change. Without this the form needs a submit button, which
   is why one is kept inside <noscript>. */
(function () {
  var form = document.querySelector(".filters");
  if (!form) return;
  var t;
  form.addEventListener("change", function () {
    clearTimeout(t);
    t = setTimeout(function () { form.submit(); }, 60);
  });
  /* one disclosure open at a time, so the panels never overlap */
  var all = [].slice.call(form.querySelectorAll("details.filter"));
  all.forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (!d.open) return;
      all.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
  document.addEventListener("click", function (e) {
    if (form.contains(e.target)) return;
    all.forEach(function (d) { d.open = false; });
  });
})();

/* Letter cascade. Splitting a label into per-letter spans would wreck it for a
   screen reader, so the original text is kept as an aria-label and the split
   pieces are hidden from the accessibility tree. Only runs when the setting is
   on, and only on buttons whose label is plain text. */
(function () {
  var root = getComputedStyle(document.documentElement);
  if (root.getPropertyValue("--btn-cascade").trim() !== "1") return;

  function split(el) {
    if (el.querySelector(".cl")) return;
    var text = el.textContent;
    if (!text || !text.trim()) return;
    /* anything richer than a single text node is left alone */
    if (el.childNodes.length !== 1 || el.firstChild.nodeType !== 3) return;
    if (!el.getAttribute("aria-label")) el.setAttribute("aria-label", text.trim());
    var frag = document.createDocumentFragment();
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      var s = document.createElement("span");
      s.className = "cl";
      s.setAttribute("aria-hidden", "true");
      s.setAttribute("data-t", ch === " " ? " " : ch);
      s.textContent = ch === " " ? " " : ch;
      /* the stagger comes from a plain custom property, not sibling-index(),
         which only reached Baseline in August 2026 */
      s.style.setProperty("--i", String(i));
      frag.appendChild(s);
    }
    el.textContent = "";
    el.appendChild(frag);
    el.classList.add("btn--casc");
  }

  function run(scope) {
    [].slice.call((scope || document).querySelectorAll(".btn")).forEach(split);
  }
  run();
  /* the cart drawer replaces its own markup, so re-split after it refreshes */
  document.addEventListener("cart:refreshed", function () { run(); });
})();

/* The header is sticky and in flow, so a hero asking for the full window is
   always taller than the space left under it. Publish the header's real height
   so the hero can subtract it rather than guessing at a fixed number. */
(function () {
  var hdr = document.querySelector(".hdr");
  if (!hdr) return;
  var set = function () {
    document.documentElement.style.setProperty("--hdr-h", hdr.offsetHeight + "px");
  };
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(hdr);
  else window.addEventListener("resize", set);
})();

/* Gallery loading mark: a plate counts as loaded once its picture has decoded,
   or for a clip, once its poster has arrived or the clip is playing. A failed
   load also ends the mark, so nothing turns forever. */
(function () {
  var marks = [].slice.call(document.querySelectorAll(".plate-load"));
  if (!marks.length) return;
  [].slice.call(document.querySelectorAll(".plates")).forEach(function (g) { g.classList.add("js-loading"); });
  marks.forEach(function (m) {
    var media = m.parentNode;
    var done = function () { media.classList.add("is-loaded"); };
    var img = media.querySelector("img");
    var vid = media.querySelector("video");
    if (img) {
      if (img.complete && img.naturalWidth) return done();
      img.addEventListener("load", done);
      img.addEventListener("error", done);
    }
    if (vid) {
      vid.addEventListener("playing", done);
      vid.addEventListener("error", done);
      // Under reduced motion clips never start, so a clip with no poster
      // would never count as loaded.
      if (!img && window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) done();
    }
    if (!img && !vid) done();
  });
})();

/* Gallery loops play only while on screen. Under prefers-reduced-motion they
   never start: the poster or first frame stands in. */
(function () {
  var vids = [].slice.call(document.querySelectorAll(".plate-vid"));
  if (!vids.length) return;
  // A clip is shown only once it is actually producing frames; until then the
  // poster image beneath it is what the plate shows.
  vids.forEach(function (v) {
    v.addEventListener("playing", function () { v.classList.add("is-live"); });
    v.addEventListener("emptied", function () { v.classList.remove("is-live"); });
  });
  if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!("IntersectionObserver" in window)) {
    vids.forEach(function (v) { v.preload = "auto"; v.play().catch(function () {}); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (v.preload === "none") { v.preload = "auto"; v.load(); }
        v.play().catch(function () {});
      } else { v.pause(); }
    });
  }, { rootMargin: "300px" });
  vids.forEach(function (v) { io.observe(v); });
})();

/* Optional per-visit shuffle. The stored order is already mixed, so this is
   only for archives meant to look different each time. */
(function () {
  [].slice.call(document.querySelectorAll(".plates[data-shuffle]")).forEach(function (grid) {
    var kids = [].slice.call(grid.children);
    for (var i = kids.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      grid.appendChild(kids[j]);
      kids.splice(j, 1);
    }
  });
})();

/* A plate opens its whole shoot. The set is assembled from data already on the
   page and the address gains a hash, so a set can be linked and the back button
   closes it. */
(function () {
  // Superseded by the editorial spread, which gives a shoot its own URL rather
  // than a hash and an overlay. Where that section is on the page this one
  // stands down, so the two do not both answer the same click.
  if (document.querySelector(".ed")) return;
  var blobs = [].slice.call(document.querySelectorAll("script.gal-data"));
  if (!blobs.length) return;

  var all = [];
  blobs.forEach(function (b) {
    try { all = all.concat(JSON.parse(b.textContent)); } catch (e) {}
  });
  if (!all.length) return;

  var sets = {};
  all.forEach(function (r) {
    if (!r.set) return;
    (sets[r.set] = sets[r.set] || []).push(r);
  });

  var view = document.createElement("div");
  view.className = "setv";
  view.innerHTML = '<div class="setv-scrim"></div><div class="setv-inner">' +
                   '<div class="setv-bar"><button class="setv-x" type="button">Close</button></div>' +
                   '<div class="setv-wrap"></div></div>';
  document.body.appendChild(view);
  var wrap = view.querySelector(".setv-wrap");
  var lastFocus = null;

  function esc(t) {
    return String(t == null ? "" : t)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function render(key) {
    var rows = sets[key];
    if (!rows || !rows.length) return false;
    var first = rows[0];
    var seen = {}, prods = [];
    rows.forEach(function (r) {
      if (r.product && r.product.url && !seen[r.product.url]) {
        seen[r.product.url] = 1; prods.push(r.product);
      }
    });
    var media = rows.map(function (r) {
      return r.video
        ? '<video src="' + esc(r.src) + '" muted loop playsinline autoplay ' +
          'width="' + esc(r.px) + '" height="' + esc(r.px) + '"></video>'
        : '<img src="' + esc(r.src) + '" alt="' + esc(r.alt) + '" loading="lazy" ' +
          'width="' + esc(r.px) + '" height="' + esc(r.px) + '">';
    }).join("");

    wrap.innerHTML =
      '<div class="setv-head"><div><h2>' + esc(first.credit || "Archive") + '</h2>' +
      (first.detail ? '<p class="sub">' + esc(first.detail) + "</p>" : "") +
      '</div><span class="n">' + rows.length +
      (rows.length === 1 ? " image" : " images") + "</span></div>" +
      '<div class="setv-grid" data-n="' +
        (rows.length > 6 ? "many" : rows.length) + '">' + media + "</div>" +
      (first.alt ? '<p class="setv-note">' + esc(first.alt) + "</p>" : "") +
      (prods.length
        ? '<div class="setv-prod"><h3>' +
          (prods.length === 1 ? "The piece" : "The pieces") + "</h3><ul>" +
          prods.map(function (p) {
            return "<li><a href=\"" + esc(p.url) + "\">" +
              (p.image ? '<img src="' + esc(p.image) + '" alt="">' : "") +
              "<span><b>" + esc(p.title) + "</b>" + esc(p.price) + "</span></a></li>";
          }).join("") + "</ul></div>"
        : "");
    return true;
  }

  function open(key, push) {
    if (!render(key)) return;
    lastFocus = document.activeElement;
    view.classList.add("open");
    document.body.style.overflow = "hidden";
    view.querySelector(".setv-x").focus();
    if (push) history.pushState({ set: key }, "", "#set-" + key);
  }
  function close(pop) {
    view.classList.remove("open");
    document.body.style.overflow = "";
    wrap.innerHTML = "";
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
    if (!pop && location.hash.indexOf("#set-") === 0) history.pushState({}, "", location.pathname);
  }

  document.addEventListener("click", function (e) {
    var plate = e.target.closest(".plate[data-set]");
    if (!plate) return;
    var key = plate.dataset.set;
    if (!key || !sets[key] || sets[key].length < 2) return;   // a lone plate keeps its own link
    e.preventDefault();
    open(key, true);
  });
  view.querySelector(".setv-x").addEventListener("click", function () { close(false); });
  view.querySelector(".setv-scrim").addEventListener("click", function () { close(false); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && view.classList.contains("open")) close(false);
  });
  window.addEventListener("popstate", function () {
    if (location.hash.indexOf("#set-") === 0) open(location.hash.slice(5), false);
    else if (view.classList.contains("open")) close(true);
  });
  if (location.hash.indexOf("#set-") === 0) open(location.hash.slice(5), false);
})();

/* ── Editorial spread ──────────────────────────────────────────────────────
   One gallery story, at its own URL, with its media at native aspect.

   Shopify gives Liquid no access to the query string, so the story is chosen
   here from the index inlined into the page. The grid and the spread share a
   route: ?story=<slug> swaps one for the other and pushState keeps the back
   button meaning what a visitor expects.                                   */
(function () {
  var root = document.querySelector(".ed");
  if (!root) return;
  var idxEl = document.getElementById("story-index");
  if (!idxEl) return;

  var INDEX, PRODUCTS;
  try {
    INDEX = JSON.parse(idxEl.textContent);
    var pe = document.getElementById("story-products");
    PRODUCTS = pe ? JSON.parse(pe.textContent) : {};
  } catch (e) { return; }

  var SLUGS = Object.keys(INDEX);
  var BASE = root.getAttribute("data-base") || "";
  var GALLERY = root.getAttribute("data-gallery") || "/pages/gallery";
  var RELN = parseInt(root.getAttribute("data-related"), 10) || 6;
  var SHOWREL = root.getAttribute("data-show-related") !== "false";
  var GARMENT = (root.getAttribute("data-garments") || "").split(",");
  var wrap = root.closest('[id^="shopify-section-"]') || root;
  var GRID_TITLE = document.title;
  var SEARCH_CACHE = {};

  // filename -> slug, so a plate in the grid knows which story it belongs to
  var FILE = {};
  SLUGS.forEach(function (s) {
    INDEX[s].a.forEach(function (a) { FILE[a[0]] = s; });
  });

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function q(name) {
    var m = new RegExp("[?&]" + name + "=([^&#]*)").exec(location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, " ")) : "";
  }
  function assetUrl(file, video) { return BASE + (video ? "fv-" : "full-") + file; }

  /* Rows are justified: within a row every figure shares a height, and its
     width is its own aspect ratio's share of the row. Native ratios survive
     exactly — no figure is ever cropped to make a grid line up. */
  function pack(assets) {
    var rows = [], row = [], sum = 0;
    for (var i = 0; i < assets.length; i++) {
      var a = assets[i], ar = (a[2] && a[3]) ? a[2] / a[3] : 1;
      if (i === 0) { rows.push([a]); continue; }        // lead plate stands alone
      row.push(a); sum += ar;
      if (sum >= 1.55 || row.length >= 3) { rows.push(row); row = []; sum = 0; }
    }
    if (row.length) rows.push(row);
    return rows;
  }

  function figure(a, widthCss, lead, storyDesc) {
    var ar = (a[2] && a[3]) ? a[2] / a[3] : 1;
    var f = document.createElement("figure");
    f.className = "ed-fig";
    f.style.width = widthCss;
    var media;
    if (a[1]) {
      media = document.createElement("video");
      media.src = assetUrl(a[0], true);
      media.controls = true;
      media.playsInline = true;
      media.preload = "metadata";
      // several clips fade in from black, so the first frame is a poor
      // resting state; make-posters.py picks a lit frame instead
      media.poster = BASE + "po-" + a[0].replace(/\.mp4$/, ".jpg");
      media.setAttribute("width", a[2] || 720);
      media.setAttribute("height", a[3] || 720);
    } else {
      media = document.createElement("img");
      media.src = assetUrl(a[0], false);
      media.alt = a[4] || "";
      media.decoding = "async";
      if (!lead) media.loading = "lazy";
      media.setAttribute("width", a[2] || 1200);
      media.setAttribute("height", a[3] || 1500);
    }
    f.appendChild(media);
    // The import gave every file in a set the same sentence. It is already the
    // standfirst, so a caption only earns its place when it says something new.
    if (a[4] && a[4] !== storyDesc) {
      var cap = document.createElement("figcaption");
      cap.className = "ed-cap";
      cap.textContent = a[4];
      f.appendChild(cap);
    }
    f.setAttribute("data-ar", ar.toFixed(3));
    return f;
  }

  function renderPlates(story) {
    var host = root.querySelector(".ed-plates");
    host.textContent = "";
    pack(story.a).forEach(function (row, ri) {
      var el = document.createElement("div");
      el.className = "ed-row";
      if (ri === 0) el.style.justifyContent = "center";
      var sum = row.reduce(function (t, a) {
        return t + ((a[2] && a[3]) ? a[2] / a[3] : 1);
      }, 0);
      // A row is capped by height as well as width, so a lone square or a
      // wide landscape cannot swell to fill the page on its own.
      if (row.length === 1) el.style.justifyContent = "center";
      row.forEach(function (a) {
        var ar = (a[2] && a[3]) ? a[2] / a[3] : 1, w;
        if (ri === 0) {
          // the opening plate is sized by height, so a portrait and a
          // landscape both open the page at the same visual weight
          w = "min(100%, calc(78vh * " + ar.toFixed(3) + "))";
        } else {
          w = "min(calc((100% - " + (row.length - 1) +
              " * var(--ed-gap, 14px)) * " + (ar / sum).toFixed(5) +
              "), calc(68vh * " + ar.toFixed(3) + "))";
        }
        el.appendChild(figure(a, w, ri === 0, story.b));
      });
      host.appendChild(el);
    });
  }

  function card(p) {
    var a = document.createElement("a");
    a.className = "ed-card";
    a.href = p.url;
    a.innerHTML =
      (p.img ? '<img class="ed-card-img" src="' + esc(p.img) + '" alt="" loading="lazy" decoding="async">'
             : '<span class="ed-card-img"></span>') +
      '<span class="ed-card-t">' + esc(p.title) + "</span>" +
      '<span class="ed-card-p' + (p.available === false ? " ed-card-out" : "") + '">' +
      (p.available === false ? "Made to order" : esc(p.price)) + "</span>";
    return a;
  }

  function syncShop() {
    root.querySelector(".ed-shop").hidden =
      root.querySelector(".ed-used").hidden && root.querySelector(".ed-rel").hidden;
  }

  function renderUsed(story) {
    var box = root.querySelector(".ed-used"), host = box.querySelector(".ed-prods");
    host.textContent = "";
    var n = 0;
    (story.p || []).forEach(function (h) {
      var p = PRODUCTS[h];
      if (p) { host.appendChild(card(p)); n++; }
    });
    box.hidden = n === 0;
    return n;
  }

  /* Related pieces come from the store's own search, so they stay correct as
     the catalogue changes. Only garment tags are queried: a story tagged
     "black, music video" would otherwise return the whole catalogue. */
  function renderRelated(story, usedHandles) {
    var box = root.querySelector(".ed-rel"), host = box.querySelector(".ed-prods");
    host.textContent = "";
    box.hidden = true;
    if (!SHOWREL) { syncShop(); return; }
    var terms = (story.t || []).filter(function (t) {
      return GARMENT.indexOf(t) !== -1;
    }).slice(0, 3);
    if (!terms.length) { syncShop(); return; }

    var seen = {}, out = [];
    usedHandles.forEach(function (h) { seen[h] = 1; });

    Promise.all(terms.map(function (t) {
      // the same handful of garment terms recur across the archive, so a
      // visitor walking prev/next asks the store for "bodysuit" once
      if (!(t in SEARCH_CACHE)) {
        SEARCH_CACHE[t] = fetch("/search/suggest.json?q=" + encodeURIComponent(t) +
                   "&resources[type]=product&resources[limit]=" + RELN,
                   { headers: { Accept: "application/json" } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      }
      return SEARCH_CACHE[t];
    })).then(function (res) {
      res.forEach(function (r) {
        var list = r && r.resources && r.resources.results && r.resources.results.products;
        (list || []).forEach(function (p) {
          var h = (p.url || "").split("/products/")[1];
          h = h ? h.split("?")[0] : p.handle;
          if (!h || seen[h]) return;
          seen[h] = 1;
          out.push({ title: p.title, url: p.url, price: p.price,
                     img: p.featured_image ? (p.featured_image.url || p.featured_image) : "",
                     available: p.available });
        });
      });
      out.slice(0, RELN).forEach(function (p) { host.appendChild(card(p)); });
      box.hidden = out.length === 0;
      syncShop();
    });
  }

  function neighbours(slug) {
    var i = SLUGS.indexOf(slug);
    return [SLUGS[(i - 1 + SLUGS.length) % SLUGS.length],
            SLUGS[(i + 1) % SLUGS.length]];
  }

  function render(slug) {
    var s = INDEX[slug];
    if (!s) return false;

    root.querySelector(".ed-kicker").textContent = s.d || "";
    var slot = root.querySelector(".ed-title-slot");
    var titleEl = root.querySelector(".ed-title");
    if (!titleEl) {
      titleEl = document.createElement("h1");
      titleEl.className = "ed-title head";
      (slot || root.querySelector(".ed-head")).appendChild(titleEl);
    }
    titleEl.textContent = s.c || slug;
    root.querySelector(".ed-desc").textContent = s.b || "";

    var tags = root.querySelector(".ed-tags");
    tags.textContent = "";
    (s.t || []).forEach(function (t) {
      var li = document.createElement("li");
      li.innerHTML = '<a href="/search?q=' + encodeURIComponent(t) + '">' + esc(t) + "</a>";
      tags.appendChild(li);
    });

    renderPlates(s);
    renderUsed(s);
    renderRelated(s, s.p || []);
    syncShop();

    var src = root.querySelector(".ed-src");
    if (s.u) { src.href = s.u; src.hidden = false; } else { src.hidden = true; }

    var nb = neighbours(slug);
    [["prev", nb[0]], ["next", nb[1]]].forEach(function (pair) {
      var el = root.querySelector(".ed-" + pair[0]), o = INDEX[pair[1]];
      if (!o) { el.hidden = true; return; }
      el.hidden = false;
      el.href = GALLERY + "?story=" + encodeURIComponent(pair[1]);
      el.querySelector("span:not([aria-hidden])").textContent = o.c || pair[1];
      el.setAttribute("data-story", pair[1]);
    });

    document.title = (s.c ? s.c + " — " : "") + (s.d || "Archive");
    return true;
  }

  function siblings(hide) {
    var p = wrap.parentNode;
    if (!p) return;
    [].slice.call(p.children).forEach(function (c) {
      if (c === wrap) return;
      if (hide) {
        if (!c.hasAttribute("data-ed-hid")) {
          c.setAttribute("data-ed-hid", c.hasAttribute("hidden") ? "1" : "0");
          c.hidden = true;
        }
      } else if (c.hasAttribute("data-ed-hid")) {
        if (c.getAttribute("data-ed-hid") === "0") c.hidden = false;
        c.removeAttribute("data-ed-hid");
      }
    });
  }

  function show(slug, push) {
    if (!render(slug)) return false;
    siblings(true);
    root.hidden = false;
    if (push) history.pushState({ story: slug }, "",
      GALLERY + "?story=" + encodeURIComponent(slug));
    window.scrollTo(0, 0);
    var h = root.querySelector(".ed-title");
    if (h) { h.setAttribute("tabindex", "-1"); h.focus({ preventScroll: true }); }
    return true;
  }

  function hide(push) {
    root.hidden = true;
    document.title = GRID_TITLE;
    root.querySelectorAll(".ed-fig video").forEach(function (v) { v.pause(); });
    siblings(false);
    if (push) history.pushState({}, "", GALLERY);
  }

  /* Every plate in the grid opens its story, including the 81 that were
     single-image and so had no set to open before. */
  function wirePlates() {
    [].slice.call(document.querySelectorAll(".plate")).forEach(function (pl) {
      if (pl.hasAttribute("data-story")) return;
      var m = pl.querySelector("img, video, source");
      var url = m ? (m.currentSrc || m.src || m.getAttribute("src") || "") : "";
      var f = url.split("/").pop().split("?")[0].replace(/^gal-/, "");
      var slug = FILE[f];
      if (!slug) return;
      pl.setAttribute("data-story", slug);
      if (pl.tagName === "A" && !pl.getAttribute("href")) {
        pl.href = GALLERY + "?story=" + encodeURIComponent(slug);
      }
    });
  }

  document.addEventListener("click", function (e) {
    if (!e.target.closest) return;
    var back = e.target.closest(".ed-back");
    if (back && !root.hidden && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.button) {
      e.preventDefault();
      hide(true);
      return;
    }
    var t = e.target.closest("[data-story]");
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var slug = t.getAttribute("data-story");
    if (!INDEX[slug]) return;
    // let a plate that links to a product keep doing that
    if (t.classList.contains("plate") && t.tagName === "A" &&
        t.getAttribute("href") && t.getAttribute("href").indexOf("?story=") === -1) return;
    e.preventDefault();
    show(slug, true);
  });

  window.addEventListener("popstate", function () {
    var s = q("story");
    if (s && INDEX[s]) show(s, false); else hide(false);
  });

  wirePlates();
  var initial = q("story");
  if (initial && INDEX[initial]) show(initial, false);
})();

/* Row packing for a server-rendered spread.
   The metaobject template writes the figures itself, so the title, standfirst,
   tags and products are in the HTML a crawler reads. Only the justification
   happens here, because a row's height depends on measurements the server does
   not have. Same geometry as the inlined path: within a row every figure shares
   a height and takes its own aspect ratio's share of the width. */
(function () {
  var host = document.querySelector(".ed-plates[data-server]");
  if (!host) return;

  var figs = [].slice.call(host.children).filter(function (n) {
    return n.classList && n.classList.contains("ed-fig");
  });
  if (!figs.length) return;

  function ar(f) {
    var v = parseFloat(f.getAttribute("data-ar"));
    if (v && isFinite(v) && v > 0) return v;
    var m = f.querySelector("img, video");
    var w = m && (m.naturalWidth || m.videoWidth || m.getAttribute("width"));
    var h = m && (m.naturalHeight || m.videoHeight || m.getAttribute("height"));
    return (w && h) ? w / h : 1;
  }

  var rows = [], row = [], sum = 0;
  figs.forEach(function (f, i) {
    if (i === 0) { rows.push([f]); return; }   // lead plate stands alone
    row.push(f); sum += ar(f);
    if (sum >= 1.55 || row.length >= 3) { rows.push(row); row = []; sum = 0; }
  });
  if (row.length) rows.push(row);

  host.textContent = "";
  rows.forEach(function (r, ri) {
    var el = document.createElement("div");
    el.className = "ed-row";
    if (ri === 0 || r.length === 1) el.style.justifyContent = "center";
    var total = r.reduce(function (t, f) { return t + ar(f); }, 0);
    r.forEach(function (f) {
      var a = ar(f);
      f.style.width = ri === 0
        ? "min(100%, calc(78vh * " + a.toFixed(3) + "))"
        : "min(calc((100% - " + (r.length - 1) + " * var(--ed-gap, 14px)) * " +
          (a / total).toFixed(5) + "), calc(68vh * " + a.toFixed(3) + "))";
      el.appendChild(f);
    });
    host.appendChild(el);
  });
})();

/* Size guide: the two sides become tabs. The markup shows both one after the
   other, so the page still works if this never runs. */
(function () {
  [].slice.call(document.querySelectorAll(".sg")).forEach(function (root) {
    var tabs = root.querySelector(".sg-tabs");
    if (!tabs) return;
    var buttons = [].slice.call(tabs.querySelectorAll(".sg-tab"));
    var panels = [].slice.call(root.querySelectorAll(".sg-panel"));
    function show(side) {
      buttons.forEach(function (b) { b.setAttribute("aria-selected", b.dataset.side === side ? "true" : "false"); });
      panels.forEach(function (p) { p.hidden = p.dataset.side !== side; });
    }
    tabs.hidden = false;
    root.classList.add("is-tabbed");
    buttons.forEach(function (b) {
      b.addEventListener("click", function () { show(b.dataset.side); });
    });
    show("women");
  });
})();
